import { T } from 'react-translator-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

const ThanksReviews = ({ image }) => {
    return (
        <>
            {image && <div style={{
                backgroundImage: `url(/thanks.jpg)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: '50%',
                overflow: 'hidden',
                width: '150px',
                height: '150px',
                margin: '0 auto',
                marginBottom: '20px',
                textAlign: 'center'
            }}></div>}
            <div style={{ padding: 40, }}>
                <span className="font-size-sm d-block text-center mt-4">
                    <FontAwesomeIcon
                        icon={faCheckCircle}
                        style={{ fontSize: 80, color: "#28a745", marginTop: -20 }}
                        className="mb-1"
                    />
                </span>
                <h2 className="text-center">{T("review.thanks")}</h2>
                <div className="loading text-center mt-5 p-10">
                    <div className="spinner-border" role="status"></div>
                </div>
            </div>
        </>

    )
}

export default ThanksReviews;
